// extracted by mini-css-extract-plugin
module.exports = {"multiselect":"CriterionForm_multiselect_2Moi-","spinAround":"CriterionForm_spinAround_WTC_7"};